<template>
  <v-layout column>
    <v-dialog
      v-model="editPriorYearItemsDialogOpened"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      width="800"
      persistent
      @keydown.esc="editPriorYearItemsDialogOpened = false"
    >
      <PriorYearScheduleLineItemsDialog
        :opened.sync="priorYearScheduleLineItemsDialogOpened"
        :document="selectedPriorYearItem"
        :company-id="null"
      />
      <v-card block flat class="px-4" v-if="selectedMatch">
        <v-card-title class="pb-0">
          <span class="title">Edit Rollover Items</span>
          <v-spacer />
          <v-icon
            @click="editPriorYearItemsDialogOpened = false"
            class="error--text"
            style="cursor: pointer"
            >clear</v-icon
          >
        </v-card-title>
        <v-card-text>
          <v-layout v-if="priorYearItemsMatchLoading" align-center column>
            <v-progress-circular
              indeterminate
              size="40"
              color="primary"
            ></v-progress-circular>
          </v-layout>
          <v-layout column v-else>
            <v-layout
              class="py-1"
              v-for="priorYearItem in sortedPriorYearItems"
              :key="priorYearItem.id"
              align-center
            >
              <v-layout align-center>
                <v-text-field
                  v-model="priorYearItem.name"
                  class="default-input mr-2"
                  hide-details
                  solo
                ></v-text-field>
                <v-tooltip
                  right
                  class="ml-2"
                  style="cursor: pointer"
                  v-if="priorYearItem.name.includes('Schedule ')"
                >
                  <v-icon
                    slot="activator"
                    class="primary--text my-0 mr-2"
                    size="24"
                    @click="openEditLineItemDialog(priorYearItem)"
                    >search</v-icon
                  >
                  <div
                    v-for="priorYearScheduleLineItem in priorYearItem.prior_year_schedule_line_items"
                  >
                    {{ priorYearScheduleLineItem.category }}:
                    {{ priorYearScheduleLineItem.value }}
                  </div>
                </v-tooltip>
                <div>Page {{ priorYearItem.page_number }}</div>
              </v-layout>
              <v-tooltip bottom style="cursor: pointer">
                <v-icon
                  slot="activator"
                  class="primary--text my-0"
                  size="20"
                  @click="updatePriorYearItemName(priorYearItem)"
                  >save</v-icon
                >
                <span>Save</span>
              </v-tooltip>
              <v-tooltip bottom style="cursor: pointer">
                <v-icon
                  slot="activator"
                  class="error--text my-0"
                  size="20"
                  @click="deletePriorYearItem(priorYearItem.id)"
                  >delete</v-icon
                >
                <span>Delete</span>
              </v-tooltip>
            </v-layout>
            <v-layout align-center>
              <v-text-field
                v-model="newPriorYearItem"
                hide-details
                placeholder="Type new rollover item"
                solo
                class="default-input"
              />
              <v-btn class="primary text-none" @click="addPriorYearItem()">
                Add
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-layout column>
      <v-layout align-center class="subheading text-xs-left mb-2">
        There are {{ totalNumberOfPriorYearItemsForSelectedYear }} Rollover
        Item{{ totalNumberOfPriorYearItemsForSelectedYear > 1 ? 's' : '' }} from
        {{ numberOfEntitiesWithRollOverItemsForSelectedYear }}/{{
          companies.filter(company => company.entity_type === 'Individual')
            .length
        }}
        Individual Entit{{
          numberOfEntitiesWithRollOverItemsForSelectedYear > 1 ? 'ies' : 'y'
        }}
        for tax year
        <div style="width: 100px" class="ml-2">
          <v-select
            v-model="rolloverItemsYear"
            :items="rolloverYearOptions"
            hide-details
            class="default-input body-1"
            solo
            small
          />
        </div>
        <v-spacer />
        <sc-button-group>
          <sc-button
            type="secondary"
            :is-loading="rolloverInProgress"
            @click="rolloverToNextYear()"
            data-onboarding="true"
          >
            Rollover to {{ rolloverItemsYear + 1 }}
          </sc-button>
          <sc-button
            type="secondary"
            @click="generatePriorYearInformationReport()"
          >
            Generate Report for {{ rolloverItemsYear }}
          </sc-button>
        </sc-button-group>
      </v-layout>
      <v-layout align-center no-wrap>
        <div class="font-weight-bold mx-2">Search</div>
        <v-flex xs5>
          <v-text-field
            v-model="entitySearch"
            class="default-input subheading"
            solo
            placeholder="Search by entity name"
            hide-details
          />
        </v-flex>
        <v-flex>
          <v-switch
            class="default-input ml-2 my-0 pa-0"
            v-model="hideNoRolloverItems"
            label="Hide entities with no rollover items"
            hide-details
          />
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="entitiesWithRolloverItemsHeaders"
        :items="entitiesWithRolloverItems"
        :loading="rolloverItemsLoading"
        :search="entitySearch"
        disable-initial-sort
        :pagination.sync="entitiesWithRolloverItemsPagination"
        :rows-per-page-items="entitiesWithRolloverItemsPagination.options"
      >
        <template v-slot:items="props">
          <td class="text-xs-left">
            <a
              class="client-name mr-1"
              @click="
                changeCurrentCompany(
                  $event,
                  props.item.id,
                  `/${basePath}/${props.item.hash_id}?prior_year_items_year=${rolloverItemsYear}`,
                )
              "
              :href="
                `/${basePath}/` +
                  props.item.hash_id +
                  `?prior_year_items_year=${rolloverItemsYear}`
              "
            >
              {{ props.item.tax_return_name }}
            </a>
          </td>
          <td class="text-xs-left">
            {{ props.item.entity_type }}
          </td>
          <td class="text-xs-left">
            {{ props.item.prior_year_items_count }}
          </td>
          <td>
            <v-layout align-center>
              <v-tooltip right style="cursor: pointer">
                <v-icon slot="activator" class="primary--text">search</v-icon>
                <div
                  v-for="priorYearItem in props.item.prior_year_items.splice(
                    0,
                    20,
                  )"
                >
                  {{ priorYearItem.name }}
                </div>
                <div v-if="props.item.prior_year_items_count > 20">...</div>
              </v-tooltip>
            </v-layout>
          </td>
        </template>
        <template v-slot:no-results>
          Your search for "{{ entitySearch }}" found no results.
        </template>
      </v-data-table>
    </v-layout>

    <v-layout column v-if="isSorabanAdmin">
      <v-layout
        align-center
        class="subheading text-xs-left mb-2 font-weight-bold"
        >Rollover Item Match<v-chip small>Soraban Admin Only</v-chip>
        <v-spacer />
        <v-btn
          class="default-input error--text text-none"
          hide-details
          outline
          @click="reRunRolloverItemsReader()"
          >Re-run Rollover Items Reader for {{ rolloverItemsYear }}</v-btn
        >
        <v-btn
          class="default-input error text-none"
          hide-details
          @click="removeAllUploadedFilesForRolloverItems()"
          >Remove Uploaded Rollover Items Files for
          {{ rolloverItemsYear }}</v-btn
        >
      </v-layout>

      <v-layout align-center no-wrap>
        <div class="font-weight-bold mx-2">Search</div>
        <v-flex xs5>
          <v-text-field
            v-model="searchCriteria"
            class="default-input subheading"
            solo
            placeholder="Search by match data or match method"
            hide-details
          />
        </v-flex>
        <v-flex>
          <v-switch
            class="default-input ml-2 my-0 pa-0"
            v-model="hideMatched"
            label="Hide Matched"
            hide-details
          />
          <v-switch
            class="default-input ml-2 my-0 pa-0"
            v-model="hideUnmatched"
            label="Hide Unmatched"
            hide-details
          />
        </v-flex>

        <v-flex>
          <v-btn
            class="default-input primary--text text-none"
            hide-details
            outline
            @click="loadPriorYearItemsMatches()"
          >
            Refresh
          </v-btn>
        </v-flex>
        <v-flex>
          <v-btn
            class="default-input primary text-none"
            :disabled="isEmpty(selectedMatches)"
            hide-details
            @click="matchToEntities(selectedMatches.map(d => d.id))"
          >
            Save Selected
          </v-btn>
          <v-btn
            class="default-input primary text-none"
            :disabled="isEmpty(selectedMatches)"
            hide-details
            @click="deletedSelectedMatches()"
          >
            Delete Selected
          </v-btn>
        </v-flex>
        <v-flex>
          <v-btn
            class="default-input primary--text text-none"
            hide-details
            outline
            @click="generatePriorYearItemsMatchInformationReport()"
          >
            Generate Match Report for {{ rolloverItemsYear }}
          </v-btn>
        </v-flex>
      </v-layout>
      <v-data-table
        select-all
        v-model="selectedMatches"
        :headers="filteredPriorYearItemsHeaders"
        :items="filteredPriorYearItemsMatches"
        :loading="matchesLoading"
        :search="searchCriteria"
        disable-initial-sort
        :pagination.sync="priorYearItemsMatchPagination"
        :rows-per-page-items="priorYearItemsMatchPagination.options"
      >
        <template v-slot:items="props">
          <td>
            <v-checkbox hide-details v-model="props.selected" />
          </td>
          <td class="text-xs-left">
            <v-autocomplete
              class="default-input body-1"
              hide-details
              :loading="loadingCompanies"
              :disabled="loadingCompanies"
              solo
              clearable
              :items="companiesWithEmail"
              :value="props.item.company_id"
              @change="
                newCompanyId =>
                  savePriorYearItemsMatch(props.item, newCompanyId)
              "
              @click:clear="savePriorYearItemsMatch(props.item, null)"
              placeholder="Select entity"
              item-value="id"
              item-text="nameWithEmail"
            />
          </td>
          <td class="text-xs-left">
            {{ props.item.match_method }}
            <v-tooltip
              bottom
              v-if="
                props.item.match_method === 'Last Name and partial First Name'
              "
            >
              <v-icon slot="activator" class="error--text ml-1">warning</v-icon>
              <span>Need Review</span>
            </v-tooltip>
          </td>
          <td class="text-xs-left">
            <div v-html="props.item.formattedMatchData" />
          </td>
          <td class="text-xs-left">
            {{ props.item.prior_year_items_count }}
          </td>
          <td>
            {{ props.item.documentName }}
          </td>
          <td>
            <v-layout align-center>
              <v-tooltip right class="mr-2" style="cursor: pointer">
                <v-icon
                  slot="activator"
                  class="primary--text"
                  @click="openEditPriorYearItemsDialog(props.item)"
                  >search</v-icon
                >
                <div
                  v-for="priorYearItem in props.item.preview_prior_year_items"
                >
                  {{ priorYearItem.name }}
                </div>
                <div v-if="props.item.prior_year_items_count > 20">...</div>
              </v-tooltip>
              <v-tooltip bottom style="cursor: pointer">
                <v-icon
                  slot="activator"
                  @click="matchToEntities([props.item.id])"
                  class="primary--text"
                  >download</v-icon
                >
                <span>Save</span>
              </v-tooltip>
              <v-tooltip bottom style="cursor: pointer">
                <v-icon
                  slot="activator"
                  @click="deletePriorYearItemsMatch(props.item.id)"
                  class="error--text"
                  >delete</v-icon
                >
                <span>Delete</span>
              </v-tooltip>
            </v-layout>
          </td>
        </template>
        <template v-slot:no-results>
          Your search for "{{ searchCriteria }}" found no results.
        </template>
      </v-data-table>
    </v-layout>
    <v-layout align-center v-if="isSorabanAdmin">
      <span class="subheading font-weight-bold"
        >Uploaded Documents Status<v-chip small
          >Soraban Admin Only</v-chip
        ></span
      >
      <v-spacer />
      <v-btn
        class="default-input primary--text text-none"
        hide-details
        outline
        @click="loadPriorYearDocStatus()"
      >
        Refresh
      </v-btn>
    </v-layout>
    <v-expansion-panel>
      <v-expansion-panel-content key="successfullyImportedDocuments">
        <template v-slot:header>
          <div>Successfully Imported Items</div>
        </template>
        <v-card>
          <v-data-table
            :headers="successfullyImportedDocumentsHeader"
            :items="successfullyImportedDocuments"
            :loading="priorYearDocStatusLoading"
            disable-initial-sort
            :pagination.sync="successfullyImportedDocumentsPagination"
            :rows-per-page-items="
              successfullyImportedDocumentsPagination.options
            "
          >
            <template v-slot:items="props">
              <td>
                {{ props.item.name }}
              </td>
              <td>
                {{ props.item.document_type }}
              </td>
              <td>
                {{ props.item.generated_match_ids.length }}
              </td>
              <td>
                {{ moment(props.item.created_at).format('lll') }} ({{
                  moment(props.item.created_at).fromNow()
                }})
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-expansion-panel-content>
      <v-expansion-panel-content key="documentsInProgress">
        <template v-slot:header>
          <div>Items in Progress</div>
        </template>
        <v-card>
          <v-data-table
            :headers="documentsInProgressHeader"
            :items="documentsInProgress"
            :loading="priorYearDocStatusLoading"
            disable-initial-sort
            :pagination.sync="documentsInProgressPagination"
            :rows-per-page-items="documentsInProgressPagination.options"
          >
            <template v-slot:items="props">
              <td>
                {{ props.item.name }}
              </td>
              <td>
                {{ props.item.document_type }}
              </td>
              <td>
                {{ moment(props.item.created_at).format('lll') }} ({{
                  moment(props.item.created_at).fromNow()
                }})
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-layout>
</template>

<script>
import API from '@/api';
import { mapState, mapGetters } from 'vuex';
import isEmpty from 'lodash/isEmpty';
import { yearOptions } from '@/constants/variables';
import AdminFunctionsMixin from '@/mixins/AdminFunctionsMixin';
import moment from 'moment';
import PriorYearScheduleLineItemsDialog from '@/components/dialogs/PriorYearScheduleLineItemsDialog';
import FirmPreferenceMixins from '@/mixins/FirmPreferenceMixins';
import UtilsMixins from '@/mixins/UtilsMixins';

export default {
  name: 'FirmOperationsTab',
  props: {
    firmId: {
      type: Number,
      default: null,
    },
  },
  components: {
    PriorYearScheduleLineItemsDialog,
  },
  mixins: [AdminFunctionsMixin, FirmPreferenceMixins, UtilsMixins],
  data() {
    return {
      yearOptions,
      totalNumberOfPriorYearItemsForSelectedYear: 0,
      numberOfEntitiesWithRollOverItemsForSelectedYear: 0,
      rolloverItemsYear: 2024,
      rolloverYearOptions: yearOptions.map(year => year + 1),
      vocabValid: false,
      newPriorYearItem: '',
      selectedMatch: null,
      showDuplicateAlert: false,
      editPriorYearItemsDialogOpened: false,
      searchCriteria: '',
      entitySearch: '',
      priorYearItems: [],
      hideNoRolloverItems: false,
      priorYearItemsMatches: [],
      priorYearScheduleLineItemsDialogOpened: false,
      selectedPriorYearItem: null,
      entitiesWithRolloverItemsHeaders: [
        {
          text: 'Entity Name (Click to edit items)',
          align: 'left',
          width: '50%',
          value: 'tax_return_name',
        },
        {
          text: 'Entity Type',
          align: 'left',
          width: '20%',
          value: 'entity_type',
        },
        {
          text: 'Item Count',
          value: 'prior_year_items_count',
          sortable: true,
          width: '10%',
          class: 'text-xs-center',
        },
        {
          text: 'Preview',
          value: '',
          sortable: false,
          width: '5%',
          class: 'text-xs-center',
        },
      ],
      entitiesWithRolloverItemsPagination: {
        sortBy: 'prior_year_items_count',
        rowsPerPage: 10,
        descending: true,
        page: 1,
        options: [
          {
            text: '10',
            value: 10,
          },
          {
            text: '100',
            value: 100,
          },
          {
            text: 'All',
            value: -1,
          },
        ],
      },
      filteredPriorYearItemsHeaders: [
        {
          text: 'Company',
          align: 'left',
          width: '40%',
          value: 'company_id',
        },
        {
          text: 'Match Method',
          value: 'match_method',
          sortable: true,
          width: '5%',
          class: 'text-xs-center',
        },
        {
          text: 'Match Data',
          value: 'formattedMatchData',
          sortable: true,
          width: '20%',
          class: 'text-xs-center',
        },
        {
          text: 'Item Count',
          value: 'prior_year_items_count',
          sortable: true,
          width: '5%',
          class: 'text-xs-center',
        },
        {
          text: 'Document Name',
          value: 'documentName',
          sortable: true,
          width: '20%',
          class: 'text-xs-center',
        },
        {
          text: 'Actions',
          value: '',
          sortable: false,
          width: '100px',
          class: 'text-xs-center',
        },
      ],
      priorYearItemsMatchPagination: {
        sortBy: 'prior_year_items_count',
        rowsPerPage: 10,
        descending: true,
        page: 1,
        options: [
          {
            text: '10',
            value: 10,
          },
          {
            text: '100',
            value: 100,
          },
          {
            text: 'All',
            value: -1,
          },
        ],
      },
      hideMatched: false,
      hideUnmatched: false,
      selectedMatches: [],
      priorYearItemsMatchLoading: false,
      allRolloverItems: [],
      matchesLoading: false,
      rolloverInProgress: false,

      priorYearDocStatusLoading: false,
      successfullyImportedDocuments: [],
      documentsInProgress: [],
      successfullyImportedDocumentsPagination: {
        sortBy: 'name',
        rowsPerPage: 10,
        page: 1,
        options: [
          {
            text: '10',
            value: 10,
          },
          {
            text: '100',
            value: 100,
          },
          {
            text: 'All',
            value: -1,
          },
        ],
      },
      successfullyImportedDocumentsHeader: [
        {
          text: 'File Name',
          align: 'left',
          sortable: true,
          width: '30%',
          value: 'name',
        },
        {
          text: 'Document Type',
          value: 'document_type',
          sortable: true,
          width: '20%',
          class: 'text-xs-center',
        },
        {
          text: 'Generated Match Count',
          value: 'generated_match_ids.length',
          sortable: true,
          width: '10%',
          class: 'text-xs-center',
        },
        {
          text: 'Created at',
          value: 'created_at',
          sortable: true,
          width: '20%',
          class: 'text-xs-center',
        },
      ],
      documentsInProgressPagination: {
        sortBy: 'name',
        rowsPerPage: 10,
        page: 1,
        options: [
          {
            text: '10',
            value: 10,
          },
          {
            text: '100',
            value: 100,
          },
          {
            text: 'All',
            value: -1,
          },
        ],
      },
      documentsInProgressHeader: [
        {
          text: 'File Name',
          align: 'left',
          sortable: true,
          width: '30%',
          value: 'name',
        },
        {
          text: 'Document Type',
          value: 'document_type',
          sortable: true,
          width: '20%',
          class: 'text-xs-center',
        },
        {
          text: 'Created at',
          value: 'created_at',
          sortable: true,
          width: '20%',
          class: 'text-xs-center',
        },
      ],
    };
  },
  computed: {
    ...mapState('companies', ['companies', 'loadingCompanies']),
    companiesWithEmail() {
      return this.companies.map(c => ({
        ...c,
        nameWithEmail: `${c.tax_return_name} (${c.user.email})`,
      }));
    },
    filteredPriorYearItemsMatches() {
      let list = this.priorYearItemsMatches;
      if (this.hideMatched) {
        list = list.filter(match => !match.company_id);
      } else if (this.hideUnmatched) {
        list = list.filter(match => match.company_id);
      }
      return list.map(match => ({
        ...match,
        formattedMatchData: this.formatMatchData(match.match_data),
        documentName: this.findDocumentName(match.id),
      }));
    },
    sortedPriorYearItems() {
      return this.priorYearItems.sort((a, b) => {
        return a.page_number - b.page_number;
      });
    },
    ...mapGetters({
      currentUser: 'user',
    }),
    entitiesWithRolloverItems() {
      return this.companies
        .filter(company => company.entity_type === 'Individual')
        .map(company => {
          const priorYearItems = this.allRolloverItems.filter(
            item => item.company_id === company.id,
          );
          return {
            ...company,
            prior_year_items_count: priorYearItems.length,
            prior_year_items: priorYearItems,
          };
        })
        .filter(company => {
          if (this.hideNoRolloverItems) {
            return company.prior_year_items_count > 0;
          } else {
            return true;
          }
        });
    },
    basePath() {
      return this.newReactAppEnabled ? 'admin' : 'admin-dashboard';
    },
  },
  methods: {
    isEmpty,
    moment,
    async reRunRolloverItemsReader() {
      if (
        !confirm(
          'Are you sure you want to re-run rollover items reader? This process may take a few minutes to a half hour to complete, depending on the number of files.',
        )
      )
        return;

      try {
        const response = await API.priorYearItemsMatch.reRunRolloverItemsReader(
          this.rolloverItemsYear,
        );
        if (response.status === 200) {
          this.$store.dispatch('application/setSuccessNotification', {
            message: `Successfully re-run rollover items reader. Please refresh the page in a few minutes.`,
          });
          this.loadPriorYearDocStatus();
          this.loadPriorYearItemsMatches();
        } else {
          this.$store.dispatch('application/setErrorNotification', {
            message: `There was a problem re-running rollover items reader.`,
          });
        }
      } catch (e) {
        this.$store.dispatch('application/setErrorNotification', {
          message: `There was a problem re-running rollover items reader.`,
        });
      }
    },
    async removeAllUploadedFilesForRolloverItems() {
      if (
        !confirm(
          'Are you sure you want to remove all uploaded files for rollover items? This is not reversible, and you need to re-upload the files again.',
        )
      )
        return;

      try {
        const response = await API.priorYearItemsMatch.removeAllUploadedFilesForRolloverItems(
          this.rolloverItemsYear,
        );
        if (response.status === 200) {
          this.$store.dispatch('application/setSuccessNotification', {
            message: `Successfully removed all uploaded files for rollover items. Please refresh the page in a few minutes.`,
          });
          this.loadPriorYearDocStatus();
          this.loadPriorYearItemsMatches();
        } else {
          this.$store.dispatch('application/setErrorNotification', {
            message: `There was a problem removing all uploaded files for rollover items.`,
          });
        }
      } catch (e) {
        this.$store.dispatch('application/setErrorNotification', {
          message: `There was a problem removing all uploaded files for rollover items.`,
        });
      }
    },
    async deletedSelectedMatches() {
      await this.asyncForEach(this.selectedMatches, match =>
        this.deletePriorYearItemsMatch(match.id),
      );
      this.loadPriorYearItemsMatches();
    },
    findDocumentName(matchId) {
      const document = this.successfullyImportedDocuments.find(doc =>
        doc.generated_match_ids.includes(matchId),
      );
      return document ? document.name : '';
    },
    async changeCurrentCompany(event, companyId, path) {
      event && event.preventDefault && event.preventDefault();

      await this.$store.dispatch('resetTiles', { companyId });
      this.$router.push(path);
    },
    async addPriorYearItem() {
      const response = await API.priorYearItemsMatch.addPriorYearItem({
        itemName: this.newPriorYearItem,
        id: this.selectedMatch.id,
      });
      if (response.data.id) {
        this.priorYearItems = [...this.priorYearItems, response.data];
        this.newPriorYearItem = null;
        this.selectedMatch.prior_year_items_count =
          this.selectedMatch.prior_year_items_count + 1;
      }
    },
    openEditPriorYearItemsDialog(match) {
      this.selectedMatch = match;
      this.loadPriorYearItemsMatch(match.id);
      this.editPriorYearItemsDialogOpened = true;
    },
    async loadPriorYearItemsMatch(id) {
      this.priorYearItemsMatchLoading = true;
      const item = await API.priorYearItemsMatch.loadItemsForPriorYearItemsMatch(
        id,
      );
      this.priorYearItems = item.data;
      this.priorYearItemsMatchLoading = false;
    },
    formatMatchData(matchData) {
      let match = `Fname: ${matchData.fname}<br/>Lname: ${matchData.lname}`;
      if (matchData.email) {
        match = match + `<br/>Email: ${matchData.email}`;
      }
      if (matchData.spouse_fname) {
        match = match + `<br/>Spouse Fname: ${matchData.spouse_fname}`;
      }
      if (matchData.spouse_lname) {
        match = match + `<br/>Spouse Lname: ${matchData.spouse_lname}`;
      }
      if (matchData.spouse_email) {
        match = match + `<br/>Spouse Email: ${matchData.spouse_email}`;
      }
      return match;
    },
    async generatePriorYearInformationReport() {
      const response = await API.report.generatePriorYearInformationReport(
        this.rolloverItemsYear,
      );
      this.saveAs(
        response.data,
        `prior_year_items_report ${this.rolloverItemsYear}.xls`,
      );
    },
    async generatePriorYearItemsMatchInformationReport() {
      await API.report.generatePriorYearItemsMatchInformationReport(
        this.rolloverItemsYear,
      );
      this.$store.dispatch('application/setSuccessNotification', {
        message: `Successfully queued prior year items match information report.`,
      });
    },
    saveAs(uri, filename) {
      var link = document.createElement('a');
      if (typeof link.download === 'string') {
        link.href = uri;
        link.download = filename;
        // Firefox requires the link to be in the body
        document.body.appendChild(link);
        // simulate click
        link.click();
        // remove the link when done
        document.body.removeChild(link);
      } else {
        window.open(uri, '_blank');
      }
    },
    async loadPriorYearItemsMatches() {
      try {
        this.matchesLoading = true;
        const items = await API.priorYearItemsMatch.getAllPriorYearItemsMatches(
          this.rolloverItemsYear,
        );
        this.priorYearItemsMatches = items.data;
      } catch (e) {
        console.log(e);
      } finally {
        this.matchesLoading = false;
      }
    },
    async loadPriorYearDocStatus() {
      try {
        this.priorYearDocStatusLoading = true;
        const response = await API.priorYearItemsMatch.getPriorYearDocumentsStatus(
          this.rolloverItemsYear,
        );
        this.successfullyImportedDocuments = response.data.filter(
          doc => doc.status === 'action_required',
        );
        this.documentsInProgress = response.data.filter(
          doc => doc.status === 'processing',
        );
      } catch (e) {
        console.log(e);
      } finally {
        this.priorYearDocStatusLoading = false;
      }
    },
    async rolloverToNextYear() {
      if (
        !confirm(
          'Are you sure you want to rollover to next year? This may not be as accurate as uploading organizers from the tax software, as it will use rollover items from the previous year.',
        )
      )
        return;
      try {
        this.rolloverInProgress = true;
        await API.priorYearItem.rolloverToNextYear(this.rolloverItemsYear);
        this.$store.dispatch('application/setSuccessNotification', {
          message: `Successfully rolled over to ${this.rolloverItemsYear + 1}.`,
        });
      } catch (e) {
        this.$store.dispatch('application/setErrorNotification', {
          message: `There was a problem rolling over to ${this
            .rolloverItemsYear + 1}.`,
        });
      } finally {
        this.loadRolloverItems();
        this.rolloverInProgress = false;
      }
    },
    async loadRolloverItems() {
      try {
        this.rolloverItemsLoading = true;
        const response = await API.priorYearItem.getRolloverItemsForFirm(
          this.rolloverItemsYear,
        );
        this.totalNumberOfPriorYearItemsForSelectedYear =
          response.data.total_number_of_rollover_items_for_selected_year;
        this.numberOfEntitiesWithRollOverItemsForSelectedYear =
          response.data.number_of_entities_with_rollover_items_for_selected_year;
        this.allRolloverItems = response.data.prior_year_items;
      } catch (e) {
        this.$store.dispatch('application/setErrorNotification', {
          message: `There was a problem loading rollover items for ${this.rolloverItemsYear}.`,
        });
      } finally {
        this.rolloverItemsLoading = false;
      }
    },
    async deletePriorYearItem(priorYearItemId) {
      await API.priorYearItemsMatch.deletePriorYearItem({
        id: this.selectedMatch.id,
        priorYearItemId: priorYearItemId,
      });
      this.priorYearItems = this.priorYearItems.filter(
        item => item.id !== priorYearItemId,
      );
      this.selectedMatch.prior_year_items_count =
        this.selectedMatch.prior_year_items_count - 1;
    },
    async savePriorYearItemsMatch(item, companyId) {
      await API.priorYearItemsMatch.updatePriorYearItemsMatch({
        company_id: companyId,
        id: item.id,
      });
      this.loadPriorYearItemsMatches();
    },
    async updatePriorYearItemName(item) {
      try {
        const response = await API.priorYearItem.updatePriorYearItemName({
          priorYearItemId: item.id,
          name: item.name,
        });

        this.$store.dispatch('application/setSuccessNotification', {
          message: 'Rollover item name is successfully updated!',
        });
      } catch (e) {
        console.log(e);
        this.$store.dispatch('application/setErrorNotification', {
          message: 'Error occured. Please try again later.',
        });
      }
    },
    async matchToEntities(ids) {
      await API.priorYearItemsMatch.matchToEntities(ids);
      this.loadPriorYearItemsMatches();
      this.loadRolloverItems();
    },
    async deletePriorYearItemsMatch(id) {
      await API.priorYearItemsMatch.deletePriorYearItemsMatch(id);
      this.priorYearItemsMatches = this.priorYearItemsMatches.filter(
        item => item.id !== id,
      );
    },
    openEditLineItemDialog(priorYearItem) {
      this.selectedPriorYearItem = priorYearItem;
      this.priorYearScheduleLineItemsDialogOpened = true;
    },
  },
  created() {
    if (this.isSorabanAdmin) {
      this.loadPriorYearItemsMatches();
      this.loadPriorYearDocStatus();
    }
    this.loadRolloverItems();
  },
  watch: {
    rolloverItemsYear() {
      if (this.isSorabanAdmin) {
        this.loadPriorYearItemsMatches();
        this.loadPriorYearDocStatus();
      }
      this.loadRolloverItems();
    },
    hideUnmatched(value) {
      if (value) {
        this.hideMatched = false;
      }
    },
    hideMatched(value) {
      if (value) {
        this.hideUnmatched = false;
      }
    },
  },
};
</script>

<style>
.description-input .ql-editor {
  min-height: 80px;
}

.text-highlight-box p {
  margin: 0;
}
.text-highlight-box a {
  color: rgba(0, 0, 0, 0.87);
}
</style>
